export default {
  name: 'ModalNetworkError',
  props: ['show', 'close'],
  data() {
    return {
      titleStyle: {
        'font-weight': '600',
        'padding-right': '10px',
        'padding-left': '10px',
      },
    };
  },
};
